import React from "react";
import Particles from 'react-particles-js';
import { HubConnectionBuilder } from "@microsoft/signalr";
import './CheckinView.css'
import PowerLogo from '../assets/img/brand/poweredbyjirango.svg';
class CheckinView extends React.Component {
    state = {
        eventId: undefined,
        response: null,
        name: null,
        company: null,
        entrance: null,
        nameList: [],
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
        const eventId = this.props.match.params.id;
    
        this.setState({ eventId }, this.connectToHub);
    }

    connectToHub = () => {
        const { eventId } = this.state;
        try {
            let url = "https://jirango.com/onsitehub";
            if (window.location.host.includes("localhost")) {
                url = "https://localhost:44331/onsitehub"
            }
            this.hubConnection = new HubConnectionBuilder().withUrl(url).build();
        } catch (error) {
            this.onError(error);
        }
        this.hubConnection.on("onCheckInDisplay", this.onCheckIn);
        this.hubConnection
            .start()
            .then(() => {
                this.hubConnection
                    .invoke("registerDisplay",
                        eventId,
                    )
                    .catch(err => {
                        console.error(err);
                    });
            })
            .catch(error => {
                console.log(error)
            });
    };
    onCheckIn = (res) => {
        this.state.nameList.push(res);
        this.checkList();
    }

    checkList = () => {
        if(!this.state.name && this.state.nameList.length > 0){
            const nextPerson = this.state.nameList.shift();
            this.setState({ name: `${nextPerson.firstName} ${nextPerson.lastName}`, company: nextPerson.companyName });
            setTimeout(() => this.setState({ name: null, company:null }, this.checkList), 3000);
        }
    }
    render() {
        const { name, company } = this.state;
        return (
            <div className="hero-wrapper">
                <Particles
                    className="hero-backdrop"
                    params={{
                        particles: {
                            number: {
                                value: 50
                            },
                            size: {
                                value: 3
                            }
                        },
                        interactivity: {
                            events: {
                                onhover: {
                                    enable: true,
                                    mode: "repulse"
                                }
                            }
                        }
                    }} />
                {name ? <React.Fragment>
                    <div className={`welcome-text fade-in`}>
                        Välkommen
                    </div>
                    <div className={`attendee-text fade-in`}>
                        {name}
                    </div>
                    <div className={`company-text fade-in`}>
                        {company}
                    </div>
                </React.Fragment>
                    : null}
                    <img src={PowerLogo} style={{position:"absolute", bottom:0, zIndex:2, width:"50%"}} />

            </div>
        );
    }
}
export default CheckinView;
